import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon/index.vue'// svg组件

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('@/assets/svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)



// WEBPACK FOOTER //
// ./src/components/SvgIcon/index.js